/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListStaffAndInvitationsQueryResponse, ListStaffAndInvitationsPathParams, ListStaffAndInvitationsQueryParams, ListStaffAndInvitations400, ListStaffAndInvitations401, ListStaffAndInvitations403, ListStaffAndInvitations404, ListStaffAndInvitations409, ListStaffAndInvitations500 } from "../../types/staffController/ListStaffAndInvitations.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListStaffAndInvitationsUrl(organizationId: ListStaffAndInvitationsPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/staff-and-invitations` as const }
  return res
}

/**
 * @summary List staff and invitations
 * {@link /api/organizations/:organizationId/staff-and-invitations}
 */
export async function listStaffAndInvitations(organizationId: ListStaffAndInvitationsPathParams["organizationId"], params?: ListStaffAndInvitationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListStaffAndInvitationsQueryResponse, ResponseErrorConfig<ListStaffAndInvitations400 | ListStaffAndInvitations401 | ListStaffAndInvitations403 | ListStaffAndInvitations404 | ListStaffAndInvitations409 | ListStaffAndInvitations500>, unknown>({ method : "GET", url : getListStaffAndInvitationsUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}